/* eslint-disable max-len */
/* eslint-disable class-methods-use-this */
import gameObjectTypes from '../constants/gameObjectTypes';
import GameObjectView from './gameObjectView';

export default class CharacterView extends GameObjectView {
    constructor() {
        super(gameObjectTypes.MAIN_CHARACTER);
    }

    updateSpeedOfSpriteSheet(speedOfSpriteSheetSeconds) {
        const value = speedOfSpriteSheetSeconds.toFixed(2);

        this.gameObjectEl.updateCssVariable('--speed-of-bus', `${value}s`);
    }

    init() {
        super.init();

        this.gameObjectEl.removeClasses(['start', 'stop']);
        this.addVynil();
    }

    addVynil(mainColor = 'var(--bus-color-1)', accentColor = 'var(--bus-color-2)') {
        const vinylHtml = `
            <svg width="303" height="195" viewBox="0 0 303 195" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M270.272 44.7032C263.553 40.31 283.894 17.5398 244.985 17.5398L73.7782 25.6656C34.8693 25.6656 18.0918 28.7017 11.3735 33.0949C4.63449 37.4882 0.738281 -5.59635 0.738281 75.8133V120.021C0.738281 151.352 5.41641 194.274 7.76577 194.274H295.708C298.057 194.274 302.735 151.373 302.735 120.021V88.1181C302.735 6.68785 286.966 43.5245 280.247 39.1312L270.272 44.7032Z" fill="${mainColor}"/>
                <mask id="mask0_423_177" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="1" y="0" width="301" height="150">
                <path d="M11.0864 16.165L2.25977 25.5061L36.2715 134.707C38.8749 143.065 46.6121 148.759 55.3668 148.759H247.43C256.171 148.759 263.903 143.072 266.517 134.731L300.51 26.2561L292.013 16.897C282.536 6.45799 269.092 0.505371 254.993 0.505371H47.4283C33.6763 0.505371 20.5314 6.16946 11.0864 16.165Z" fill="${mainColor}" stroke="black"/>
                </mask>
                <g mask="url(#mask0_423_177)">
                <path d="M0.560224 -34.42L-323.729 305.866L-291.792 221.195L-473.904 417.695L337.645 427.275L316.87 -7.26257L0.560224 -34.42Z" fill="${mainColor}"/>
                <path d="M66.0479 -51.998L-203.929 235.573L-45.7746 186.039L-371.663 444.853L98.0024 163.68L35.711 176.459L217.822 16.6955L54.8692 66.2296L211.424 -98.3329L66.0479 -51.998Z" fill="${accentColor}"/>
                <path d="M352.024 -34.42L99.606 141.304L345.626 23.0941L352.024 -34.42Z" fill="${accentColor}"/>
                <path d="M-120.861 433.674L294.51 80.6083L-63.3505 441.654L-120.861 433.674Z" fill="${accentColor}"/>
                <path d="M339.224 82.1898L107.599 301.067L181.069 277.109L-10.6216 449.652L367.979 170.061L248.177 217.995L372.778 109.365L339.224 82.1898Z" fill="${accentColor}"/>
                </g>
            </svg>
        `;

        this.gameObjectEl.el.querySelector('#bus-vynil').innerHTML = vinylHtml;
    }

    update(x, y) {
        super.update(x, y);
    }

    start() {
        this.gameObjectEl.addClasses(['start']);
    }

    stop() {
        this.gameObjectEl.addClasses(['stop']);
    }

    setColorOption(color) {
        this.gameObjectEl.addClasses([`color-${color}`]);
    }

    displaySpeedBoost() {
        this.gameObjectEl.addClasses(['speed-boost-active']);
    }

    hideSpeedBoost() {
        this.gameObjectEl.removeClasses(['speed-boost-active']);
    }

    displayProtection() {
        this.gameObjectEl.addClasses(['protection-active']);
    }

    hideProtection() {
        this.gameObjectEl.removeClasses(['protection-active']);
    }

    displaySlowdown() {
        this.gameObjectEl.addClasses(['slow-active']);

        // setTimeout(() => {
        //     this.hideSlowdown();
        // }, 1000);
    }

    hideSlowdown() {
        this.gameObjectEl.removeClasses(['slow-active']);
    }

    addEffectDisplay(type) {
        this.showAdditionalElement(type);
    }

    removeEffectDisplay(type) {
        console.log(`remove effect ${type}`);
    }

    removeAllEffectsDisplay() {
        this.hideAllAdditionalElements();
    }
}
